module.exports = __webpack_public_path__ + "img/btn-hamburguer.ee2f6a21.svg";